import { render, staticRenderFns } from "./UserTopBottomSections.vue?vue&type=template&id=71ab87fa&"
import script from "./UserTopBottomSections.vue?vue&type=script&lang=js&"
export * from "./UserTopBottomSections.vue?vue&type=script&lang=js&"
import style0 from "./UserTopBottomSections.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports